<div id="blackbox-setup">
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit()">
    <div class="steps">
      <!-- Blackbox -->
      <div class="step step-1" [class]="step == 1 ? 'active' : ''">
        <h3>Blackbox bestimmen</h3>
        <p>Welche Blackbox ist einzurichten?</p>

        <div>
          <label for="tags">
            <span ngbTooltip="Standard erlaubt schnelles Laden und Eco bedeutet kosteneffizientes Laden.">
              Verfügbare Blackboxen
            </span>
          </label>

          <ng-select id="select-blackbox" [items]="entitiesAvailable" i18n-[placeholder]="@@BlackboxSelect"
            [placeholder]="'Bitte Seriennummer auswählen'" [closeOnSelect]="true" [clearSearchOnAdd]="true"
            [selectableGroupAsModel]="false" [clearable]="false" appendTo="body" formControlName="serialNumber"
            bindLabel="serialNumber" i18n-notFoundText="@@NoEntriesAvailable" notFoundText="Keine Einträge vorhanden"
            (keydown)="tabToStep($event)" (change)="selectEntity()" autofocus>
          </ng-select>
        </div>
      </div>

      <!-- Customer -->
      <div class="step step-2" [class]="step == 2 ? 'active' : ''">
        <h3>Kunde auswählen</h3>
        <p>Welcher Kunde ist mir dieser Blackbox ausgestattet?</p>

        <div>
          <label>
            <span>
              Verfügbare Kunden
            </span>
          </label>
          <ng-select id="select-blackbox-customer" [items]="customersAvailable"
            i18n-[placeholder]="@@BlackboxCustomerSelect" [placeholder]="'Bitte Kunde auswählen'" [closeOnSelect]="true"
            [clearSearchOnAdd]="true" [selectableGroupAsModel]="false" [clearable]="false" formControlName="customer"
            appendTo="body" bindLabel="id" i18n-notFoundText="@@NoEntriesAvailable"
            notFoundText="Keine Einträge vorhanden" (change)="getMasterUserAndChargingStations()"
            (keydown)="tabToStep($event)">

            <ng-template ng-label-tmp let-item="item">
              <div style="display: flex; align-items: center;">
                <span style="flex: 0 0 40px; text-align: left;">{{ item.id }}</span>
                <span
                  style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 10px;">{{
                  item.company || item.name || item.firstName + ' ' + item.lastName }}</span>
                <span style="flex: 2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.email
                  }}</span>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <div style="display: flex; align-items: center;">
                <span style="flex: 0 0 40px; text-align: left;">{{ item.id }}</span>
                <span
                  style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 10px;">{{
                  item.company || item.name || item.firstName + ' ' + item.lastName }}</span>
                <span style="flex: 2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.email
                  }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <!-- Blackbox address -->
      <div class="step step-3" [class]="step == 3 ? 'active' : ''">
        <h3>Adresse der Blackbox bestätigen</h3>
        <p>Welcher Standort hat diese Blackbox installiert?</p>

        <div style="padding-bottom: 20px;">
          <label>
            <span>
              Verfügbare Adressen des Kunden
            </span>
          </label>
          <ng-select id="select-blackbox-address" [items]="addresses" i18n-[placeholder]="@@BlackboxAddressSelect"
            [placeholder]="'Bitte Adresse auswählen'" [closeOnSelect]="true" [clearSearchOnAdd]="true"
            [selectableGroupAsModel]="false" [clearable]="false" formControlName="address" appendTo="body"
            bindLabel="id" i18n-notFoundText="@@NoEntriesAvailable" notFoundText="Keine Einträge vorhanden"
            (keydown)="tabToPreviousStep($event)">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.street + ' ' + item.houseNumber + ' in ' + item.postalCode + ' ' + item.city }}</span>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.street + ' ' + item.houseNumber + ' in ' + item.postalCode + ' ' + item.city }}</span>
            </ng-template>
          </ng-select>
        </div>

        <p style="margin-bottom: 8px;">
          Adresse der Blackbox
        </p>
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px;">
          <input type="text" class="form-control" placeholder="Straße"
            [value]="formService.form.value['address']?.street" style="grid-column: span 2;" disabled />

          <input type="text" class="form-control" placeholder="Hausnummer"
            [value]="formService.form.value['address']?.houseNumber" style="grid-column: span 1;" disabled />

          <input type="text" class="form-control" placeholder="PLZ"
            [value]="formService.form.value['address']?.postalCode" style="grid-column: span 1;" disabled />

          <input type="text" class="form-control" placeholder="Ort" [value]="formService.form.value['address']?.city"
            style="grid-column: span 2;" disabled (keydown)="tabToNextStep($event)" />
        </div>
      </div>

      <!-- Charging Stations of same address -->
      <div class="step step-4" [class]="step == 4 ? 'active' : ''">
        <h3>Ladestationen am Standort steuern</h3>
        <p>Welche Ladestationen sind von der Blackbox zu steuern?</p>
        <p *ngIf="entity?.chargingStations?.length < 1">Es sind Ladestationen vorausgewählt mit derselben Addresse der
          Blackbox (Schritt 3).</p>

        <div id="list-blackbox-charging-stations">
          <table class="table">
            <tbody formGroupName="chargingStations">
              <tr *ngFor="let chargingStation of chargingStationsAvailableForInputs; let i = index"
                class="d-md-table-row linkTableRow">
                <td class="m-0 pl-0 pr-4 position-relative">
                  <input type="checkbox" class="m-1 form-check-input"
                    [checked]="chargingStationsAtAddress.includes(chargingStation)" [id]="'chargingStationAtIndex' + i"
                    [formControlName]="chargingStation.id">
                </td>
                <td>{{ chargingStation.name }}</td>
                <td>{{ chargingStation.manufacturer?.name }}</td>
                <td>{{ chargingStation.model?.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Color scheme of charging stations -->
      <div class="step step-5" [class]="step == 5 ? 'active' : ''">
        <h3>Statusfarben gestalten</h3>
        <p>Die Änderungen betreffen alle CUBOS-Ladestationen, die über die Blackbox gesteuert werden.</p>
        <p>Es ist unbedingt zu beachten, dass Farben eine Signalfunktion ausüben. Deshalb wird empfohlen,
          nur die Farben des Status "Available" zu verändern.</p>

        <div id="charging-stations-color-settings" class="d-grid gap-1 justify-content-center align-items-stretch">
          <ul id="color-settings-set">
            <li *ngFor="let status of colorsEditable">
              <a (click)="editColor(status)"
                [class]="editingColor.chargingPointSignal == status.chargingPointSignal ? 'active' : ''">
                <svg x="0px" y="0px" width="23.9" height="27.5" viewBox="0 0 239.8 275.9" xml:space="preserve"
                  [style]="'--outsideColor: '+status.outsideColor.hex+'; --insideColor: '+status.insideColor.hex"
                  [class]="'status-' + status.chargingPointSignal.toLowerCase()">
                  <path class="outer" style="fill: var(--outsideColor)"
                    d="M199.5,185.1L199.5,185.1L199.5,185.1L146.1,216l-23.4,13.5l0,0l0,0l0,46.3l0,0l117-67.5l0-135l-40.1,23.2L199.5,185.1L199.5,185.1z" />
                  <path class="outer" style="fill: var(--outsideColor)"
                    d="M40.2,185.1L40.2,185.1L40.2,185.1L93.5,216l23.4,13.5l0,0l0,0v46.3l0,0L0,208.3v-135l40.2,23.2V185.1z" />
                  <path class="outer" style="fill: var(--outsideColor)"
                    d="M119.8,46.4l76.8,44.3l40.1-23.2L119.8,0L2.9,67.5L43,90.7C43,90.7,119.8,46.4,119.8,46.4z" />
                  <path class="inner" style="fill: var(--insideColor)"
                    d="M69.7,106.1L69.7,106.1l50.1,28.9h0l50.1-28.9l-50.1-28.9l0,0L69.7,106.1L69.7,106.1z" />
                  <path class="inner" style="fill: var(--insideColor)"
                    d="M122.7,140.8v57.9l50.1-28.9v-57.9L122.7,140.8z" />
                  <path class="inner" style="fill: var(--insideColor)"
                    d="M66.8,111.9v57.9l50.1,28.9v-57.9C116.9,140.8,66.8,111.9,66.8,111.9z" />
                </svg>
                <span>{{ status.chargingPointSignal }}</span>
              </a>
            </li>
          </ul>

          <div id="color-settings-preview" *ngIf="editingColor"
            [class]="'status-' + editingColor.chargingPointSignal.toLowerCase()"
            class="d-flex justify-content-center align-items-center">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
              y="0px" stroke="#53769a" stroke-width=".5px" width="400px" height="400px" viewBox="0 0 400 400"
              style="enable-background:new 0 0 400 400;"
              [style]="'--outsideColor: '+editingColor.outsideColor.hex+'; --insideColor: '+editingColor.insideColor.hex + '; filter: url(\#shadow) url(\#glow) url(\#fog);'"
              xml:space="preserve">
              <filter id='glow'>
                <!-- Glow -->
                <feGaussianBlur in="SourceGraphic" stdDeviation=".5" result="blurA" />
                <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blurB" />
                <feMerge result="blur-merged">
                  <feMergeNode in="blurA" />
                  <feMergeNode in="blurB" />
                </feMerge>
                <feColorMatrix result="glow-blur" in="blur-merged" type="matrix" />
                <feMerge>
                  <feMergeNode in="glow-blur" />
                  <feMergeNode in="blurA" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
              <filter id='shadow'>
                <!-- Inset Shadow -->
                <feOffset dx='0' dy='0' />
                <feGaussianBlur stdDeviation='.5' result='offset-blur' />
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse' />
                <feFlood flood-color='black' flood-opacity='.5' result='color' />
                <feComposite operator='in' in='color' in2='inverse' result='shadow' />
                <feComposite operator='over' in='shadow' in2='SourceGraphic' />
              </filter>
              <filter id='fog'>
                <!-- Inset Shadow -->
                <feOffset dx='0' dy='0' />
                <feGaussianBlur stdDeviation='3' result='offset-blur' />
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse' />
                <feFlood [flood-color]='this.editingColor.outsideColor.hex' flood-opacity='1' result='color' />
                <feComposite operator='in' in='color' in2='inverse' result='shadow' />
                <feComposite operator='over' in='shadow' in2='SourceGraphic' />
              </filter>
              <path class="outer" style="fill: var(--outsideColor)"
                d="M218.503,123.008L218.503,123.008L218.503,123.008l-13.024,7.448l-5.774,3.292l0,0l0,0l0.009,11.469l0,0l28.81-16.628l-1.006-31.556l-9.43,5.269L218.503,123.008L218.503,123.008z" />
              <path class="outer" style="fill: var(--outsideColor)"
                d="M179.497,123.008L179.497,123.008L179.497,123.008l12.999,7.448l5.774,3.292l0,0l0,0l-0.009,11.469l0,0l-28.785-16.628l1.006-31.556l9.454,5.269L179.497,123.008z" />
              <path class="outer" style="fill: var(--outsideColor)"
                d="M198.988,91l18.355,9.979l9.421-5.254l-27.775-14.942l-27.776,14.942l9.42,5.254L198.988,91z" />
              <path class="inner" style="fill: var(--insideColor)"
                d="M186.967,104.5L186.967,104.5l12.021,6.684l0,0l12.021-6.684l-12.021-6.586l0,0L186.967,104.5L186.967,104.5z" />
              <path class="inner" style="fill: var(--insideColor)"
                d="M199.69,112.537l0.01,13.734l12.214-6.907l-0.191-13.531L199.69,112.537z" />
              <path class="inner" style="fill: var(--insideColor)"
                d="M186.253,105.833l-0.191,13.531l12.214,6.907l0.011-13.734C198.286,112.537,186.253,105.833,186.253,105.833z" />
            </svg>
          </div>

          <div id="color-settings-inputs" *ngIf="editingColor" class="d-flex justify-content-center align-items-center">
            <div
              *ngIf="editingColor.chargingPointSignal.toString() == 'Idle' || editingColor.chargingPointSignal.toString() == 'Reading'"
              class="d-flex gap-2 p-4 flex-column justify-content-center align-items-center text-center">
              <label for="outer-color">
                <svg x="0px" y="0px" width="47.8" height="55" viewBox="0 0 239.8 275.9" xml:space="preserve"
                  [style]="'--outsideColor: '+editingColor.outsideColor.hex+'; --insideColor: '+editingColor.insideColor.hex"
                  stroke-width="2px" stroke="black">
                  <path style="fill: var(--outsideColor)" d="M199.5,185.1L199.5,185.1L199.5,185.1L146.1,216l-23.4,13.5l0,0l0,0l0,46.3l0,0l117-67.5l0-135l-40.1,23.2
                    L199.5,185.1L199.5,185.1z" />
                  <path style="fill: var(--outsideColor)"
                    d="M40.2,185.1L40.2,185.1L40.2,185.1L93.5,216l23.4,13.5l0,0l0,0v46.3l0,0L0,208.3v-135l40.2,23.2V185.1z" />
                  <path style="fill: var(--outsideColor)"
                    d="M119.8,46.4l76.8,44.3l40.1-23.2L119.8,0L2.9,67.5L43,90.7C43,90.7,119.8,46.4,119.8,46.4z" />
                </svg>
                <input type="color" name="outer-color" [value]="editingColor.outsideColor.hex"
                  (input)="setStatusColor('outside', $event)" class="mt-2">
              </label>

              <label for="inner-color">
                <svg x="0px" y="0px" width="47.8" height="55" viewBox="0 0 239.8 275.9" xml:space="preserve"
                  [style]="'--outsideColor: '+editingColor.outsideColor.hex+'; --insideColor: '+editingColor.insideColor.hex"
                  stroke-width="2px" stroke="black">
                  <path style="fill: var(--insideColor)"
                    d="M69.7,106.1L69.7,106.1l50.1,28.9h0l50.1-28.9l-50.1-28.9l0,0L69.7,106.1L69.7,106.1z" />
                  <path style="fill: var(--insideColor)" d="M122.7,140.8v57.9l50.1-28.9v-57.9L122.7,140.8z" />
                  <path style="fill: var(--insideColor)"
                    d="M66.8,111.9v57.9l50.1,28.9v-57.9C116.9,140.8,66.8,111.9,66.8,111.9z" />
                </svg>
                <input type="color" name="inner-color" [value]="editingColor.insideColor.hex"
                  (input)="setStatusColor('inside', $event)">
              </label>

              <button type="button" class="btn btn-yellow mt-4" data-bs-dismiss="modal" (click)="resetStatusColor()"
                i18n-ngbTooltip [ngbTooltip]="'Änderung zurücksetzen'"
                [disabled]="!editedStatusColors.includes(editingColor)">
                <app-svg source="icons/feather/refresh-ccw" height="18"></app-svg>
              </button>
            </div>

            <div
              *ngIf="editingColor.chargingPointSignal.toString() != 'Idle' && editingColor.chargingPointSignal.toString() != 'Reading'"
              class="d-flex gap-2 p-4 flex-column justify-content-center align-items-center text-center">
              <label for="outer-color">
                <svg x="0px" y="0px" width="47.8" height="55" viewBox="0 0 239.8 275.9" xml:space="preserve"
                  [style]="'--outsideColor: '+editingColor.outsideColor.hex+'; --insideColor: '+editingColor.insideColor.hex"
                  stroke-width="2px" stroke="black">
                  <path style="fill: var(--outsideColor)" d="M199.5,185.1L199.5,185.1L199.5,185.1L146.1,216l-23.4,13.5l0,0l0,0l0,46.3l0,0l117-67.5l0-135l-40.1,23.2
                    L199.5,185.1L199.5,185.1z" />
                  <path style="fill: var(--outsideColor)"
                    d="M40.2,185.1L40.2,185.1L40.2,185.1L93.5,216l23.4,13.5l0,0l0,0v46.3l0,0L0,208.3v-135l40.2,23.2V185.1z" />
                  <path style="fill: var(--outsideColor)"
                    d="M119.8,46.4l76.8,44.3l40.1-23.2L119.8,0L2.9,67.5L43,90.7C43,90.7,119.8,46.4,119.8,46.4z" />
                  <path style="fill: var(--insideColor)"
                    d="M69.7,106.1L69.7,106.1l50.1,28.9h0l50.1-28.9l-50.1-28.9l0,0L69.7,106.1L69.7,106.1z" />
                  <path style="fill: var(--insideColor)" d="M122.7,140.8v57.9l50.1-28.9v-57.9L122.7,140.8z" />
                  <path style="fill: var(--insideColor)"
                    d="M66.8,111.9v57.9l50.1,28.9v-57.9C116.9,140.8,66.8,111.9,66.8,111.9z" />
                </svg>
                <input type="color" name="outer-color" [value]="editingColor.outsideColor.hex"
                  (input)="setStatusColor('both', $event)" class="mt-2">
              </label>

              <button type="button" class="btn btn-yellow mt-4" data-bs-dismiss="modal" (click)="resetStatusColor()"
                i18n-ngbTooltip [ngbTooltip]="'Änderung zurücksetzen'"
                [disabled]="!editedStatusColors.includes(editingColor)">
                <app-svg source="icons/feather/refresh-ccw" height="18"></app-svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Energy Meter -->
      <div class="step step-6" [class]="step == 6 ? 'active' : ''">
        <h3>Energiemeter anlegen</h3>
        <p>Welche Energiemeter messen die Energie welcher Einrichtungen?</p>
        <p>Der Typ des Energiemeters ist davon abhängig, wo das Energiemeter verbaut und welcher Strom zu messen ist.
          Eine Blackbox kann mehrere Energiemeter gleichzeitig messen.</p>

        <div class="energy-meters" formArrayName="energyMeters">
          <div class="energy-meter" *ngFor="let meter of energyMeters, index as i" [formGroupName]="i">
            <label for="input-blackbox-name-{{i}}">Name</label>
            <input type="text" id="input-blackbox-name-{{i}}" class="form-control"
              placeholder="Optionaler Name dieses Energiemeters" formControlName="name" />

            <label for="select-blackbox-type-{{i}}">Typ</label>
            <ng-select id="select-blackbox-type-{{i}}" [items]="energyMeterTypes" formControlName="energyMeterType"
              i18n-[placeholder]="@@BlackboxSelectType" [placeholder]="'Bitte auswählen'" [closeOnSelect]="true"
              [clearable]="false" appendTo="body" bindLabel="id" i18n-notFoundText="@@NoEntriesAvailable"
              notFoundText="Keine Einträge vorhanden">
              <ng-template ng-label-tmp let-item="item">
                <img *ngIf="item.name == 'Photovoltaik-System'" src="assets/icons/feather/sun.svg" [alt]="item">
                <img *ngIf="item.name == 'Battery'" src="assets/icons/feather/battery-charging.svg" [alt]="item">
                <img *ngIf="item.name == 'Building'" src="assets/icons/feather/home.svg" [alt]="item">
                <img *ngIf="item.name == 'Grid Connection'" src="assets/icons/feather/powergrid.svg" [alt]="item">
                <img *ngIf="item.name == 'Charging Park'" src="assets/icons/feather/charging-station-group.svg"
                  [alt]="item">
                &nbsp;<span>{{ item.name }}</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <img *ngIf="item.name == 'Photovoltaik-System'" src="assets/icons/feather/sun.svg" [alt]="item">
                <img *ngIf="item.name == 'Battery'" src="assets/icons/feather/battery-charging.svg" [alt]="item">
                <img *ngIf="item.name == 'Building'" src="assets/icons/feather/home.svg" [alt]="item">
                <img *ngIf="item.name == 'Grid Connection'" src="assets/icons/feather/powergrid.svg" [alt]="item">
                <img *ngIf="item.name == 'Charging Park'" src="assets/icons/feather/charging-station-group.svg"
                  [alt]="item">
                &nbsp;<span>{{ item.name }}</span>
              </ng-template>
            </ng-select>

            <label for="input-blackbox-powerLimit-{{i}}">Leistungsgrenze</label>
            <input type="number" id="input-blackbox-powerLimit-{{i}}" class="form-control" formControlName="powerLimitInKw" />

            <label style="white-space: nowrap;" for="switch-blackbox-show-inverted-{{i}}">Show Inverted</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="switch-blackbox-show-inverted-{{i}}"
                formControlName="showInverted" />
            </div>

            <label style="white-space: nowrap;" for="switch-blackbox-record-inverted-{{i}}">Record Inverted</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="switch-blackbox-record-inverted-{{i}}"
                formControlName="recordInverted" />
            </div>

            <label for="input-blackbox-ip-{{i}}">IP-Addresse</label>
            <input type="text" id="input-blackbox-ip-{{i}}" class="form-control" placeholder="IP-Adresse"
              formControlName="ipAddress" />

            <label for="input-blackbox-mac-{{i}}">MAC-Addresse</label>
            <input type="text" id="input-blackbox-mac-{{i}}" class="form-control" placeholder="Optionale MAC-Addresse"
              formControlName="macAddress" />

            <button class="btn btn-yellow mt-2" id="button-remove-energy-meter-{{i}}" (click)="removeEnergyMeter(i)">
              <app-svg source="icons/feather/minus-circle" height="18"></app-svg>
              <span class="d-none d-md-inline ps-2">Energiemeter entfernen</span>
            </button>
          </div>

          <a *ngIf="step == 6" class="energy-meter" (click)="addEnergyMeter()">
            <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
          </a>
        </div>
      </div>
    </div>
  </form>
</div>